import {Entity} from '@s-ui/domain'

export class ReservationEntity extends Entity {
  /**
   * @param {Object} data
   * @param {String} data.adId
   * @param {String} data.adReservationStatus
   * @param {String} data.reservationId
   */
}
